import createModelStore from "../../utils/createModelStore";
import CarBrand from "../../services/CarBrand";

const carBrands = createModelStore<CarBrand.Model, "carBrands">("carBrands");

export default carBrands;
